/* Project Import will be here */
import { post, IRequest } from "../index";
/* Project Import will be here */

export const getSupportHelplineApi = () => {
  const request: IRequest = { subUrl: `/Principal/ContactHelpline` };
  return post(request);
}
